import { createContext } from "react";
export var FormContext = createContext({});
//# sourceMappingURL=FormContext.js.map